function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleIllustrationReportReceipt = function SvgSimpleIllustrationReportReceipt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 68",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 68 68"
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m59.699 20.758 1.466-10.995-3.683 2.139-2.263-3.306-3.05 2.598-2.629-3.166-3.45 2.481-2.137-3.226-2.9 2.491-2.678-2.798-6.117 45.867 3.683-2.139 2.263 3.307 3.051-2.598 2.629 3.165 3.45-2.481 2.137 3.226 2.9-2.491 2.677 2.798 4.651-34.872z",
    style: {
      fill: "#fffaf0",
      stroke: "#002140",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.896 58.842H13.604V11h21.592l12.701 13.828v34.014z",
    style: {
      fill: "#fee45e",
      stroke: "#002140",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.896 24.828H35.478L35.195 11l12.701 13.828z",
    style: {
      fill: "#fed607",
      stroke: "#002140",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
};
export default SvgSimpleIllustrationReportReceipt;